import script from "./RenewRegConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RenewRegConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./RenewRegConfirmationModal.vue?vue&type=style&index=0&id=add80ed6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-add80ed6"]])

export default __exports__